import { MasterpassLinkToMerchantRequest } from 'Models/MasterpassSdkModels';

/**
 * Mobil WebView akışında Masterpass hesabını üye işyerine bağlama gövdesi
 * (`accountService.linkToMerchant`).
 *
 * ⚠️ Yeni SDK bu işlem için yalnızca `accountKey` + `userId` alır. Eski gövdedeki
 * `sendSmsLanguage`, `sendSms`, `referenceNo`, `token`, `cardAliasName`, `fp`,
 * `clientId`, `dateTime`, `version`, `clientType` alanlarının hiçbirinin karşılığı
 * yoktur; gönderilse bile SDK whitelist'i tarafından silinirdi.
 *
 * Özellikle `clientId: '34706580'` (prod üye işyeri kimliği) artık kodda
 * tutulmuyor — merchant kimliği JWT'nin `MerchantId` claim'inden gelip
 * `Masterpass.setMerchantId()` ile kuruluyor.
 *
 * `accountKey` (telefon) ve `userId` JWT'den geldiği için gövde boştur; imza,
 * çağıran mobil view'ları kırmamak için korunmuştur.
 */
export const mobileMasterpassConnect = (_params?: any): Partial<MasterpassLinkToMerchantRequest> => ({});
